

















import Vue from 'vue';
import { ErrorModel } from '@/types';

export default Vue.extend({
  name: 'ErrorNotification',
  props: {
    errorModel: {
      type: Object as () => ErrorModel,
      required: true
    }
  },
  methods: {
    navigate() {
      if (this.errorModel.buttonRoutePath) {
        window.location.href = this.errorModel.buttonRoutePath;
      }
      const params = this.errorModel.buttonRouteParams || undefined;
      this.$router.push({
        name: this.errorModel.buttonRouteName,
        params
      });
    }
  }
});
